import { render, staticRenderFns } from "./SuppliesInfocardForm.vue?vue&type=template&id=bca956f4&"
import script from "./SuppliesInfocardForm.vue?vue&type=script&lang=js&"
export * from "./SuppliesInfocardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports